
require('../../../../remotes-delegate.js?remote=searchv1@/remote-search-web/chunks/remoteEntry')
//hasDelegateMarkers
"use strict";
// placeholder file for delegate module injection
//# sourceMappingURL=internal-delegate-hoist.js.map